/**
 * GraphQL node ID を解析します。
 *
 * backend/pkg/domain/idmgr.Parse と互換な標準 Base64 の `kind:path` 形式を解析します。
 * API 境界では意味のない ID を早期に拒否するため、kind と path の両方を必須にします。
 * Base64 decoder の寛容な入力解釈を避けるため、再エンコード結果も比較します。
 */
export type ParsedGraphQLId = {
  kind: string;
  path: string;
};

const STANDARD_BASE64_PATTERN = /^[A-Za-z0-9+/]*={0,2}$/;

export function parseGraphQLId(value: string): ParsedGraphQLId | null {
  if (
    value.length === 0 ||
    value.length % 4 !== 0 ||
    !STANDARD_BASE64_PATTERN.test(value)
  ) {
    return null;
  }

  let decoded: string;
  try {
    decoded = atob(value);
  } catch {
    return null;
  }

  if (btoa(decoded) !== value) {
    return null;
  }

  const separatorIndex = decoded.indexOf(":");
  if (separatorIndex <= 0 || separatorIndex === decoded.length - 1) {
    return null;
  }

  return {
    kind: decoded.slice(0, separatorIndex),
    path: decoded.slice(separatorIndex + 1),
  };
}

export function isGraphQLIdOfKind(
  value: string,
  expectedKind: string,
): boolean {
  return parseGraphQLId(value)?.kind === expectedKind;
}
